<div class="mega_body-content">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-8 col-lg-8 pl-0">
        <div class="mega_header-information__sub-header" *ngIf="!isEditMegaFlow">Confirmation</div>
        <div class="mega_header-information__sub-header" *ngIf="isEditMegaFlow">
          Pool Edits Confirmed ({{ poolNumber }})
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-4 col-lg-4">
        <button
          class="button fm-secondary-button float-end"
          (click)="downloadMegaPDF()"
          [disabled]="downloadPDFButtonClicked"
        >
          <i class="fa fa-file-pdf-o button-icon"></i>EXPORT PDF
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <br />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 pl-0">
        {{ commitResponse.actionMessage }}
      </div>
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 pr-0">
        <div class="float-end">
          <p><span class="fw-bold">Dealer: </span> {{ commitResponse.dealerName }}</p>
          <p><span class="fw-bold">Dealer Contact: </span>{{ commitResponse.traderName }}</p>
          <p>
            <span class="fw-bold">Committed Date: </span>
            {{ commitResponse.committedDate | date: 'MM/dd/yyyy' }}
          </p>
        </div>
      </div>
    </div>
    <!--divclass="visible-xs-12 hidden-md hidden-lg col-12 col-sm-12 col-md-5 col-lg-5 pr-0">
      <div>
        <p class="mb-5"><span class="fw-bold">Dealer: </span>{{ commitResponse.dealerName }}</p>
        <p class="mb-5"><span class="fw-bold">Dealer Contact: </span>{{ commitResponse.traderName }}</p>
        <p class="mb-5"><span class="fw-bold">Committed Date: </span>{{ commitResponse.committedDate  | date:'MM/dd/yyyy' }}</p>
      </div>
    </div-->
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
    <div class="line-break"></div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
      <div>Pool Type</div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-7 col-lg-7 pl-0">
      <ng-container *ngIf="commitResponse.megaType === 'SFFIXMEGA'">
        <div class="fw-bold-and-size">Single Family Fixed Rate</div>
      </ng-container>
      <ng-container *ngIf="commitResponse.megaType === 'SFARMMEGA'">
        <div class="fw-bold-and-size">Single Family ARM</div>
      </ng-container>
      <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
        <div class="fw-bold-and-size">Multi Family Fixed Rate</div>
      </ng-container>
      <ng-container *ngIf="commitResponse.megaType === 'MFARMMEGA'">
        <div class="fw-bold-and-size">Multi Family ARM</div>
      </ng-container>
    </div>
    <div class="col-12 col-sm-12 col-md-5 col-lg-5 pr-0">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 mt-3">
          <span class="float-end"
            ><span class="fw-bold">Export:</span
            ><a class="export-links float-end" (click)="exportMultiMegaExcelConfirmationDetails()"
              >Excel</a
            ></span
          >
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 pr-0">
          <span class="float-end">
            <span class="fw-bold-and-size total-mega-count">Total Pools: 1</span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-10">
    <div class="fm-cdx-table">
      <table class="fm-cdx-table__static">
        <thead>
          <tr class="th_row">
            <th class="th_column">POOL #</th>
            <th class="th_column width-25">CUSIP</th>
            <th class="th_column width-25">PREFIX</th>
            <ng-container *ngIf="commitResponse.megaType === 'SFFIXMEGA'">
              <th class="th_column th_column--is-numeric">COUPON</th>
            </ng-container>
            <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
              <th class="th_column th_column--is-numeric">HIGH COUPON</th>
            </ng-container>
            <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
              <th class="th_column th_column--is-numeric">LOW COUPON</th>
            </ng-container>
            <ng-container
              *ngIf="
                commitResponse.megaType === 'SFARMMEGA' || commitResponse.megaType === 'MFARMMEGA'
              "
            >
              <th class="th_column">SUBTYPE</th>
            </ng-container>
            <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
            <th class="th_column pl-85">SETTLEMENT</th>
            <th class="th_column th_column--is-numeric">FEE</th>
          </tr>
        </thead>
        <tbody>
          <tr class="td_row commit-mega-table-header">
            <td class="td_cell">
              <span id="megaNumber" class="commit-to-recive-color">{{
                commitResponse.poolNumber
              }}</span>
            </td>
            <td class="td_cell">
              <span id="cusip" class="commit-to-recive-color">{{ commitResponse.cusip }}</span>
            </td>
            <td class="td_cell">
              <span id="prefix">{{
                commitResponse?.prefixCode ? commitResponse?.prefixCode : ''
              }}</span>
            </td>
            <ng-container *ngIf="commitResponse.megaType === 'SFFIXMEGA'">
              <td class="td_cell td_cell--is-numeric">
                <span id="sfFixedCoupon">{{
                  commitResponse?.sfFixedCoupon | number: '1.3-3'
                }}</span>
              </td>
            </ng-container>
            <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
              <td class="td_cell td_cell--is-numeric">
                <span id="mfHighCoupon">{{ commitResponse?.mfHighCoupon | number: '1.3-3' }}</span>
              </td>
            </ng-container>
            <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
              <td class="td_cell td_cell--is-numeric">
                <span id="mfLowCoupon">{{ commitResponse?.mfLowCoupon | number: '1.3-3' }}</span>
              </td>
            </ng-container>
            <ng-container
              *ngIf="
                commitResponse.megaType === 'SFARMMEGA' || commitResponse.megaType === 'MFARMMEGA'
              "
            >
              <td class="td_cell">
                <span id="sfARMSubType">{{ commitResponse?.sfARMSubType }}</span>
              </td>
            </ng-container>
            <td class="td_cell td_cell--is-numeric">
              <span id="tradeAmount">{{
                commitResponse?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
              }}</span>
            </td>
            <ng-container *ngIf="!showEarlyCloseLegend">
              <td class="td_cell">
                <span id="tradeSettlementDate">{{
                  commitResponse?.tradeSettlementDate | date: 'MM/dd/yyyy'
                }}</span>
              </td>
            </ng-container>
            <ng-container *ngIf="showEarlyCloseLegend">
              <td class="td_cell">
                <span id="tradeSettlementDate-earlyClose"
                  >{{ commitResponse?.tradeSettlementDate | date: 'MM/dd/yyyy'
                  }}<i class="fa fa-asterisk legend-icon pl-3"></i
                ></span>
              </td>
            </ng-container>
            <ng-container *ngIf="commitResponse?.feeDollars !== null">
              <td class="td_cell td_cell--is-numeric">
                <ng-container
                  *ngIf="checkDisclaimerStatus(commitResponse?.prefixCode); else noDisclaimer"
                >
                  {{ needsDisclaimer() }}
                  <span id="newFeeDollars" class="fw-bold fee-warning-red"
                    >{{ commitResponse?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                  </span>
                </ng-container>
                <ng-template #noDisclaimer>
                  <span id="newFeeDollars" class="fw-bold"
                    >{{ commitResponse?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                  </span>
                </ng-template>
              </td>
            </ng-container>
            <ng-container *ngIf="commitResponse?.feeTicks !== null">
              <td class="td_cell td_cell--is-numeric">
                <ng-container
                  *ngIf="checkDisclaimerStatus(commitResponse?.prefixCode); else noTickDisclaimer"
                >
                  {{ needsDisclaimer() }}
                  <span id="newFeeTicks" class="fw-bold fee-warning-red"
                    >{{ commitResponse?.feeTicks | number: '1.3-3' }}/32*
                  </span>
                </ng-container>
                <ng-template #noTickDisclaimer>
                  <span id="newFeeTicks" class="fw-bold"
                    >{{ commitResponse?.feeTicks | number: '1.3-3' }}/32
                  </span>
                </ng-template>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
    <p class="fee-warning-red">
      {{ disclaimerMessage }}
    </p>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-25" *ngIf="showEarlyCloseLegend">
    <p>
      <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
      someone from the Structured Transactions team is available to complete this transaction.
    </p>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
    <div class="buttons">
      <button
        class="button fm-primary-button button--margin-right"
        *ngIf="showSubmitPoolInfo"
        (click)="allowUploadCollateral()"
      >
        Upload Collateral Information
      </button>
      <button class="button fm-secondary-button" (click)="navigatePageToCommittedPools()">
        View Committed Pools
      </button>
    </div>
  </div>

  <div class="row mt-25">
    <div class="col-12 col-sm-12 col-md-5 col-lg-5 pl-0 fw-bold">
      <div>
        Pricing Summary -
        <span class="mega-pricing-pricing-month" *ngIf="!isMayPricingMonth"
          >{{ pricingSummary?.pricingMonth | date: 'MMM' }}.
          {{ pricingSummary?.pricingMonth | date: 'yyyy' }}</span
        >
        <span class="mega-pricing-pricing-month" *ngIf="isMayPricingMonth"
          >{{ pricingSummary?.pricingMonth | date: 'MMM' }}
          {{ pricingSummary?.pricingMonth | date: 'yyyy' }}</span
        >
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-7 col-lg-7 pr-0 fw-bold">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-8">
          <span class="float-end"
            >Total Volume :
            <span>{{ totalMonthlyVolume | currency: 'USD' : 'symbol' : '1.0' }}</span></span
          >
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 pr-0">
          <span class="float-end">
            <span class="total-mega-pricing-count"
              >Total Pools: {{ pricingSummaryList.length }}</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="col-12 col-sm-12 col-md-12 col-lg-12 mega-pricing-update-table mt-10 px-0"
    *ngIf="pricingSummaryList.length > 0"
  >
    <div class="fm-cdx-table">
      <table class="fm-cdx-table__static">
        <thead>
          <tr class="th_row">
            <th class="th_column">POOL #</th>
            <th class="th_column width-25">CUSIP</th>
            <th class="th_column width-25">PREFIX</th>
            <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
            <th class="th_column pl-85">SETTLEMENT</th>
            <th class="th_column th_column--is-numeric">FEE</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="commitResponse.megaType === 'MFFIXMEGA'">
            <tr
              class="td_row commit-mega-table-header"
              *ngFor="let megaPricing of pricingSummaryList; trackBy: trackByIdentity"
            >
              <td class="td_cell width-poolNumber-MFFIX">
                <span id="pricing-update-mf-mega-number">{{ megaPricing?.poolNumber }}</span>
              </td>
              <td class="td_cell width-cusip-MFFIX">
                <span id="pricing-update-mf-cusip">{{ megaPricing?.cusip }}</span>
              </td>
              <td class="td_cell width-prefix-MFFIX">
                <span id="pricing-update-mf-prefixCode">{{ megaPricing?.prefixCode }}</span>
              </td>
              <td class="td_cell td_cell--is-numeric width-tradeAmount-MFFIX">
                <span id="pricing-update-mf-trade-amount">{{
                  megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                }}</span>
              </td>
              <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                <td class="td_cell pl-85 width-settelmentDate-MFFIX">
                  <span id="pricing-update-settlementDate-MFFIX">{{
                    megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                  }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="megaPricing.earlyCloseFlag">
                <td class="td_cell pl-85 width-settelmentDate-MFFIX">
                  <span id="pricing-update-settlementDate-earlyClose-MFFIX"
                    >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                    }}<i class="fa fa-asterisk legend-icon pl-3"></i
                  ></span>
                </td>
              </ng-container>
              <ng-container *ngIf="megaPricing?.feeDollars !== null">
                <td class="td_cell td_cell--is-numeric">
                  <span id="pricingFee-mf-feeDollars" class="fw-bold">{{
                    megaPricing?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="megaPricing?.feeTicks !== null">
                <td class="td_cell td_cell--is-numeric">
                  <span id="pricingFee-mf-feeTicks" class="fw-bold"
                    >{{ megaPricing?.feeTicks | number: '1.3-3' }}/32
                  </span>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <ng-container *ngIf="commitResponse.megaType !== 'MFFIXMEGA'">
            <tr
              class="td_row commit-mega-table-header"
              *ngFor="let megaPricing of pricingSummaryList; trackBy: trackByIdentity"
            >
              <td class="td_cell width-poolNumber">
                <span id="pricing-update-mega-number">{{ megaPricing?.poolNumber }}</span>
              </td>
              <td class="td_cell width-cusip">
                <span id="pricing-update-cusip">{{ megaPricing?.cusip }}</span>
              </td>
              <td class="td_cell width-prefixCode">
                <span id="pricing-update-prefixCode">{{ megaPricing?.prefixCode }}</span>
              </td>
              <td class="td_cell td_cell--is-numeric width-tradeAmount">
                <span id="pricing-update-trade-amount">{{
                  megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                }}</span>
              </td>
              <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                <td class="td_cell pl-85 width-settelmentDate">
                  <span id="pricing-update-settlementDate">{{
                    megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                  }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="megaPricing.earlyCloseFlag">
                <td class="td_cell pl-85 width-settelmentDate">
                  <span id="pricing-update-settlementDate-earlyClose"
                    >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                    }}<i class="fa fa-asterisk legend-icon pl-3"></i
                  ></span>
                </td>
              </ng-container>
              <ng-container *ngIf="megaPricing?.feeDollars !== null">
                <td class="td_cell td_cell--is-numeric">
                  <ng-container
                    *ngIf="
                      checkDisclaimerStatus(megaPricing?.prefixCode) && !megaPricing?.isAllocated;
                      else noDisclaimerListItem
                    "
                  >
                    {{ listNeedsDisclaimer() }}
                    <span id="pricingFee-feeDollars" class="fw-bold fee-warning-red"
                      >{{ megaPricing?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                    </span>
                  </ng-container>
                  <ng-template #noDisclaimerListItem>
                    <span id="pricingFee-feeDollars" class="fw-bold"
                      >{{ megaPricing?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                    </span>
                  </ng-template>
                </td>
              </ng-container>
              <ng-container *ngIf="megaPricing?.feeTicks !== null">
                <td class="td_cell td_cell--is-numeric">
                  <ng-container
                    *ngIf="
                      checkDisclaimerStatus(megaPricing?.prefixCode) && !megaPricing?.isAllocated;
                      else noTickDisclaimerListItem
                    "
                  >
                    {{ listNeedsDisclaimer() }}
                    <span id="pricingFee-feeTicks" class="fw-bold fee-warning-red"
                      >{{ megaPricing?.feeTicks | number: '1.3-3' }}/32*
                    </span>
                  </ng-container>
                  <ng-template #noTickDisclaimerListItem>
                    <span id="pricingFee-feeTicks" class="fw-bold"
                      >{{ megaPricing?.feeTicks | number: '1.3-3' }}/32
                    </span>
                  </ng-template>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <p class="fee-warning-red">
      {{ recentlyCommittedDisclaimerMessage }}
    </p>
    <div
      class="col-12 col-sm-12 col-md-12 col-lg-12 mt-25"
      *ngIf="showEarlyCloseLegendPricingSummary"
    >
      <p>
        <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
        someone from the Structured Transactions team is available to complete this transaction.
      </p>
    </div>
  </div>
</div>
